// extracted by mini-css-extract-plugin
module.exports = {"content-meta":"content-meta","bm-icon":"bm-icon","source-origin":"source-origin","icon":"icon","content-location":"content-location"};